class HttpStatus {
}

HttpStatus.SUCCESS = 200
HttpStatus.BAD_REQUEST = 400
HttpStatus.UNAUTHORIZED = 401
HttpStatus.FORBIDDEN = 403
HttpStatus.NOT_FOUND = 404
HttpStatus.INTERNAL_SERVER_ERROR = 500

class ContentType {
}

ContentType.URL_ENCODED = 'application/x-www-form-urlencoded'
ContentType.JSON = 'application/json'
ContentType.FORM_DATA = 'multipart/form-data'
ContentType.HTML = 'text/html'
ContentType.PDF = 'application/pdf'

class ResponseType {
}

ResponseType.BLOB = 'blob'
const BACK_END_ERROR_MESSAGE = 'message'

class Action {
    constructor(actionID, url = '') {
        this.actionID = actionID
        this.client = new NorseClient(url)

        this.form = new FormAction(actionID, this.client)
        this.template = new TemplateAction(actionID, this.client)
        this.modal = new ModalAction(actionID, this.client)
        this.download = new Downloader(actionID, this.client)
    }

    performAction(data = {}, config) {
        let norseData = this.client.getNorseData(data, this.actionID)
        return this.client.post(norseData, config)
    }

    dispatchStartAction(app) {
        app.loader.dispatchStartLoading(this.actionID)
        return this
    }

    //Useful for manual catching of errors
    dispatchStopAction(app) {
        app.loader.dispatchStopLoading(this.actionID)
    }

    dispatchClearAction(app) {
        app.loader.dispatchStopLoading('')
        return this
    }

    setErrorHandler(errorHandler) {
        this.client.setErrorHandler(errorHandler)
    }

    enableManualCatch() {
        this.client.enableManualCatch()
        return this
    }
}

class FormAction {
    static errorsKey = 'errors'
    static redirectUrlKey = 'redirect_url'
    messageKey = 'message'

    constructor(actionID, client) {
        this.actionID = actionID
        this.client = client
        this.showToast = true
        this.canRedirect = true
    }

    setErrorHandler(errorHandler) {
        this.client.setErrorHandler(errorHandler)
    }

    setGenericErrorHandler(app) {
        this.client.setErrorHandler((error) => {
            this.handleErrors(error, app)
        })
    }

    handleErrors(error, app) {
        app.loader.dispatchStopLoading(this.actionID)
        let errors = error.response.data[FormAction.errorsKey]
        FormAction.updateErrors(this.formId, errors, app)

        if (this.showToast) {
            let message = error.response.data[BACK_END_ERROR_MESSAGE]
            this._handleMessageErrors(message, app)
            this._handleNonFieldError(errors, app)
        }
    }

    _handleMessageErrors(message, app) {
        if (message) {
            app.toaster.addMessage(message, 'error')
        }
    }

    _handleNonFieldError(errors, app) {
        if (!errors) return

        let nonField = errors['__all__']
        if (nonField) {
            app.toaster.addMessage(nonField, 'error')
        }
    }

    disableToast() {
        this.showToast = false
    }

    disableRedirect() {
        this.canRedirect = false
    }

    /**
     *  Pass the element's id to extract the data from the HTML and post it.
     * */
    post_element(app, elementId = NorseForm.DEFAULT_FORM_ID) {
        let form = new NorseForm(elementId)
        return this.post(form, app, elementId)
    }

    post(data = {}, app, formId = NorseForm.DEFAULT_FORM_ID) {
        this.formId = formId

        // This allows the programmer to  define their own error handler outside
        this.client.setToaster(app.toaster)
        if (this.client.hasGenericErrorHandler()) {
            this.setGenericErrorHandler(app)
        }

        if (data instanceof NorseForm) {
            data = data.getData()
        }

        let norseData = this.client.getNorseData(data, this.actionID)
        return this.client.post(norseData).then((response) => {
            return new Promise((outerResolve) => {
                FormAction.updateErrors(this.formId, [], app)
                if (response.data) {
                    const {redirect_url} = response.data
                    if (this.canRedirect
                        && redirect_url) {
                        window.location = response.data[FormAction.redirectUrlKey]
                        return outerResolve(response)
                    }
                    if (this.messageKey in response.data) {
                        app.toaster.addMessage(response.data[this.messageKey], 'success')
                    }
                }
                app.loader.dispatchStopLoading(this.actionID)
                return outerResolve(response)
            })
        })
    }

    static updateErrors(formId, errors, app) {
        let newErrors = {}
        newErrors[formId] = errors
        app.errors = newErrors
    }
}

class TemplateAction {
    constructor(actionID, client) {
        this.actionID = actionID
        this.client = client
    }

    setErrorHandler(errorHandler) {
        this.client.setErrorHandler(errorHandler)
    }

    setGenericErrorHandler(app) {
        this.client.setErrorHandler((error) => {
            this.handleErrors(error, app)
        })
    }

    handleErrors(error, app) {
        app.loader.dispatchStopLoading(this.actionID)
        let message = error.response.data[BACK_END_ERROR_MESSAGE]
        if (message) {
            app.toaster.addMessage(message, 'error')
        }
    }

    load(templateId, app, data = {}) {
        this.client.setToaster(app.toaster)
        if (this.client.hasGenericErrorHandler()) {
            this.setGenericErrorHandler(app)
        }

        if (data instanceof NorseForm) {
            data = data.getData()
        }

        let norseData = this.client.getNorseData(data, this.actionID)
        return this.client.post(norseData).then((response) => {
            return new Promise((outerResolve) => {
                if (response.data && typeof response.data === 'object') {
                    if (FormAction.redirectUrlKey in response.data) {
                        window.location = response.data[FormAction.redirectUrlKey]
                        return outerResolve(response)
                    }
                }

                this._addNewTemplate(templateId, response.data, app)
                app.loader.dispatchStopLoading(this.actionID)
                return outerResolve(response)
            })
        })
    }

    _addNewTemplate(templateId, template, app) {
        let newTemplates = {}
        if (Object.keys(app.templates).includes(templateId)) {
            delete app.templates[templateId]
        }

        newTemplates[templateId] = template
        newTemplates = mergeTwoDicts(newTemplates, app.templates)
        app.templates = newTemplates
    }
}

class MODAL_STATE {
}

MODAL_STATE.OPEN = 'OPEN'
MODAL_STATE.CLOSED = 'CLOSED'

class ModalAction {
    constructor(actionID, client) {
        this.actionID = actionID
        this.client = client
    }

    setErrorHandler(errorHandler) {
        this.client.setErrorHandler(errorHandler)
    }

    setGenericErrorHandler(app) {
        this.client.setErrorHandler((error) => {
            this.handleErrors(error, app)
        })
    }

    handleErrors(error, app) {
        app.loader.dispatchStopLoading(this.actionID)
        let message = error.response.data[BACK_END_ERROR_MESSAGE]
        if (!message) {
            ErrorHandler.processUnexpectedError(app.toaster, error)
            return
        }

        app.toaster.addMessage(message, 'error')
    }

    open(modalId, app, data = {}) {
        this.client.setToaster(app.toaster)
        if (this.client.hasGenericErrorHandler()) {
            this.setGenericErrorHandler(app)
        }

        if (data instanceof NorseForm) {
            data = data.getData()
        }

        let norseData = this.client.getNorseData(data, this.actionID)
        return this.client.post(norseData).then((response) => {
            return new Promise((outerResolve) => {
                if (response.data && typeof response.data === 'object') {
                    if (FormAction.redirectUrlKey in response.data) {
                        window.location = response.data[FormAction.redirectUrlKey]
                        return outerResolve(response)
                    }
                }

                this._addNewModal(modalId, response.data, app)
                return outerResolve(response)
            })
        })
    }

    load(modalId, app, data = {}) {
        this.client.setToaster(app.toaster)
        if (this.client.hasGenericErrorHandler()) {
            this.setGenericErrorHandler(app)
        }

        if (data instanceof NorseForm) {
            data = data.getData()
        }

        let norseData = this.client.getNorseData(data, this.actionID)
        return this.client.post(norseData).then((response) => {
            return new Promise((outerResolve) => {
                if (response.data && typeof response.data === 'object') {
                    if (FormAction.redirectUrlKey in response.data) {
                        window.location = response.data[FormAction.redirectUrlKey]
                        return outerResolve(response)
                    }
                }

                this._addNewModal(modalId, response.data, app)
                return outerResolve(response)
            })
        })
    }

    _addNewModal(modalId, template, app) {
        // Do the following way in order to trigger the watcher
        // in the template component
        let newModals = {}
        newModals[modalId] = {template: template, state: MODAL_STATE.OPEN}
        newModals = mergeTwoDicts(app.modals, newModals)
        app.modals = newModals
    }
}

class Downloader {
    constructor(actionID, client) {
        this.actionID = actionID
        this.client = client
    }

    pdf(data = {}, app) {
        let contentType = ContentType.PDF

        let norseData = this.client.getNorseData(data.getData(), this.actionID)
        let config = new NorseClient().formConfig
        config['responseType'] = ResponseType.BLOB
        return this.client.post(norseData, config).then((response) => {
            return new Promise((outerResolve) => {
                const report = new Blob([response.data], {type: contentType})
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(report)
                const regExpFilename = /filename="(?<filename>.+)\.(.+)"/
                const filename = regExpFilename.exec(response.headers['content-disposition'])?.groups?.filename ?? null
                link.download = filename || 'report'
                link.click()
                window.URL.revokeObjectURL(link.href)
                return outerResolve(response)
            })
        })
    }

    xls(data = {}, app) {
        let contentType = ContentType.XLS

        let norseData = this.client.getNorseData(data, this.actionID)
        let config = new NorseClient().formConfig
        config['responseType'] = ResponseType.BLOB
        return this.client.post(norseData, config).then((response) => {
            return new Promise((outerResolve) => {
                const report = new Blob([response.data], {type: contentType})
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(report)
                const regExpFilename = /filename="(?<filename>.+)"/
                const filename = regExpFilename.exec(response.headers['content-disposition'])?.groups?.filename ?? null
                link.download = filename || 'report'
                link.click()
                window.URL.revokeObjectURL(link.href)
                return outerResolve(response)
            })
        })
    }
}


function getCsrfToken() {
    return document.querySelector('[name=csrfmiddlewaretoken]')?.value || ''
}

class NorseResponseTools {
    constructor(response) {
        this.response = response
    }

    getContentTypes() {
        return this.response.headers['content-type'] || []
    }

    isJSON() {
        return this.getContentTypes().includes(ContentType.JSON)
    }

    isHTML() {
        return this.getContentTypes().includes(ContentType.HTML)
    }

}

// Enhance axios response with custom functions under norseTools
axios.interceptors.response.use(response => {
        response.norseTools = new NorseResponseTools(response)
        return response
    }, error => {
        const response = error.response
        if (!!response) {
            response.norseTools = new NorseResponseTools(response)
        }

        throw error
    }
)

class NorseClientData {
    constructor(data) {
        this._checkType(data)
        this.data = data
        this._addedData = []
    }

    _checkType(data) {
        if (this._isHtmlFormElement(data) || this._isObject(data)) {
            return
        }
        throw TypeError('HTMLFormElement or Plain json is allowed')
    }


    addData(key, value) {
        this._addedData.push({[key]: value})
    }

    getFormData() {
        if (this._isHtmlFormElement(this.data)) {
            let formData = new FormData(this.data)
            let url = this.data.getAttribute('action')
            if (url) {
                formData.append('action_url', url)
            }
            return this._mergeData(formData, this._addedData)
        }

        if (this._isObject(this.data)) {
            let formData = new FormData()
            for (const key in this.data) {
                if (this._isArray(this.data[key])) {
                    this._addArray(formData, key, this.data[key])
                    continue
                }
                formData.append(key, this.data[key])
            }
            return this._mergeData(formData, this._addedData)
        }

    }

    getDataAsDict() {
        let dataObject = this.data
        this._addedData.forEach(obj => {
            dataObject = Object.assign(dataObject, obj)
        })
        return dataObject
    }

    static getNorseClientData(data) {
        if (data instanceof NorseClientData) {
            return data
        }
        return new NorseClientData(data)
    }

    _addArray(formData, key, data) {
        data.forEach(value => {
            formData.append(key, value)
        })
    }

    _mergeData(formData, added_data) {
        added_data.forEach(data => {
            Object.keys(data).forEach(key => {
                formData.append(key, data[key])
            })
        })
        return formData
    }

    _isHtmlFormElement(data) {
        return data instanceof HTMLFormElement
    }

    _isObject(data) {
        return data && data.constructor === Object
    }

    _isArray(data) {
        return data && data.constructor === Array
    }
}

function getProfileIdentityToken() {
    let meta = document.querySelector('meta[name="profile-identity"]')
    return meta ? meta.getAttribute('content') : null
}

class NorseClient {
    constructor(url = '') {
        this.csrfToken = '{{ csrf_token }}'
        this.url = url

        this.actionId = null
        this.toaster = null
        this.isManualCatchEnabled = false

        this.errorHandler = this.genericErrorHandler
        this._onReject = (error) => {
            if (error instanceof NetworkError) {
                if(error?.message === "Request aborted") {
                    //  Sometimes when user clicks too frequently, an action might be in process
                    // when user decided to redirect to another page.
                    return
                }

                //  No response in the error object most probably because of network error
                console.error('Network error: ', error)
                this.toaster.addMessage(error.message, 'error')
                return
            }

            if (error instanceof ForbiddenError) {
                // Either session timed out or user switched to another profile
                window.location = '/'
                return
            }

            if (error instanceof RequestClientError) {
                let message = error?.response?.data?.message
                if (message) {
                    this.toaster.addMessage(message, 'error')
                    return
                }

                this.toaster.addMessage(gettext('Not allowed to do that'), 'error')
            }

            // 500 below
            if (error instanceof UnexpectedError) {
                // console.error(error)
                ErrorHandler.processUnexpectedError(this.toaster, error, this.actionId)
                return
            }

            return this.errorHandler(error)
        }
    }

    setToaster(toaster) {
        this.toaster = toaster
    }

    setErrorHandler(errorHandler) {
        this.errorHandler = errorHandler
    }

    genericErrorHandler(error) {
        // [!]  Toaster is not accessible here
        if (!this.toaster) {
            throw 'You need to have toaster set on the NorseClient.'
        }
        ErrorHandler.processError(this.toaster, error, HttpStatus.BAD_REQUEST)
    }

    enableManualCatch() {
        this.isManualCatchEnabled = true
        let handler = (error) => {
            throw error
        }
        this.setErrorHandler(handler)
    }

    get(data = {}) {
        let config = this.formConfig
        config['params'] = data
        let get = axios.get(this.url, config)

        let wrap = new Promise((outer_resolve) => {
            get.then((response) => {
                outer_resolve(response)
            }).catch((error) => {
                ErrorHandler.processError(error)
            })
        })
        return wrap
    }

    getNorseData(data, actionID) {
        this.actionId = actionID
        let norseData = NorseClientData.getNorseClientData(data)
        norseData.addData('action', actionID)
        return norseData
    }

    getFormData(data) {
        if (data instanceof NorseClientData) {
            return data.getFormData()
        }
        let norseData = new NorseClientData(data)
        return norseData.getFormData()
    }

    post(data = {}, config = this.formConfig) {
        let formData = this.getFormData(data)
        if (!this.url) {
            this.url = formData.get('action_url') || ''
        }
        let post = axios
            .post(this.url, formData, config)
            .catch((error) => {
                const instance = resolveError(error)
                throw instance
            })

        return new Promise((outerResolve, outerReject) => {
            return post.then(outerResolve, this._onReject)
                .catch((error) => {

                    if (this.isManualCatchEnabled) {
                        return outerReject(error)
                    }

                    // [!]  There is an error in the error handler
                    const msg = 'Error in error handler: ' + error.message
                    this.toaster.addMessage(msg, 'error')
                })
        })
    }

    hasGenericErrorHandler() {
        return this.errorHandler === this.genericErrorHandler
    }

    get formConfig() {
        let headers = {
            'Content-Type': ContentType.URL_ENCODED,
            'X-Requested-With': 'XMLHttpRequest'
        }

        let profileIdentity = getProfileIdentityToken()
        if (profileIdentity) {
            headers['X-Profile-Identity'] = profileIdentity
        }

        headers['X-CSRFToken'] = getCsrfToken()
        return {
            headers: headers
        }
    }
}

class HTTPResponseError {
    constructor(response) {
        this.response = response
    }
}

class JSONBadRequestError extends HTTPResponseError {
    constructor(response) {
        super(response)

        this.message = 'Unhandled error'
        if (response.data.message) {
            this.message = response.data.message
        }
    }
}

class HTMLBadRequestError extends HTTPResponseError {
    constructor(response) {
        super(response)
        this.html_content = response.data
    }
}

class NetworkError {
    constructor(error) {
        this.message = error.message
    }
}

class UnexpectedError {
    constructor(error) {
        this.originalError = error
        this.response = error.response
    }
}

class ForbiddenError {
    constructor(error) {
        this.originalError = error
        this.response = error.response
    }
}

class RequestClientError {
    constructor(error) {
        this.originalError = error
        this.response = error.response
    }
}


function resolveError(error) {
    if (!error.response) {
        return new NetworkError(error)
    }

    const response = error.response
    if (response.status === HttpStatus.BAD_REQUEST) {
        if (response.norseTools.isHTML()) {
            return new HTMLBadRequestError(response)
        }

        if (response.norseTools.isJSON()) {
            return new JSONBadRequestError(response)
        }
    }

    if (response.status === HttpStatus.FORBIDDEN) {
        return new ForbiddenError(error)
    }

    if (response.status > 400 && 500 > response.status) {
        return new RequestClientError(error)
    }

    return new UnexpectedError(error)
}

const getDay = (date) => {
    return moment(new Date(date)).locale('sv').format('dddd')
}

const getDate = (date) => {
    return moment(new Date(date)).locale('sv').date()
}

const getWeek = (date) => {
    return moment(new Date(date)).locale('sv').isoWeek()
}

const getMonth = (date) => {
    return moment(new Date(date)).locale('sv').format('MMM')
}

const getYear = (date) => {
    return moment(new Date(date)).locale('sv').format('YYYY')
}

const isCurrentYear = (date) => {
    return moment(date).year() === moment(new Date()).year()
}

const isCurrentWeek = (date) => {

    if (!isCurrentYear(date)) {
        return false
    }

    return getWeek(date) === getWeek(new Date())
}

const isCurrentDay = (date) => {
    return moment(date).format(Constants.DATE_FORMAT) === moment(new Date()).format(Constants.DATE_FORMAT)
}

const isFirstOfMonth = (date) => {
    return moment(date).date() === 1
}
class NorseElement {
    static getInputDataFromElement(elementId) {
        let rootElement = document.getElementById(elementId)
        if (!rootElement) {
            throw Error('No element with id: ' + elementId)
        }

        return this.extractInputDataFromElement(rootElement)
    }

    static extractInputDataFromElement(element) {
        let data = {}
        let elements = element.querySelectorAll('input, textarea, select')
        for (let element of elements) {
            if ('name' in element.attributes) {
                const name = element.attributes['name'].value.split(' ')[0];
                if (element.tagName === 'INPUT' && element.type === 'radio') {
                    if (element.checked) {
                        data[name] = element.value;
                    }
                    continue
                }
                if (element.tagName === 'INPUT' && element.type === 'checkbox') {
                    if(!element.checked){
                        continue
                    }
                    if (data.hasOwnProperty(name)) {
                        data[name].push(element.value)
                        continue
                    }
                    data[name] = [element.value]
                    continue
                }
                data[name] = element.value;
            }
        }
        return data
    }

    static isChildOf(child, parent) {
        while ((child = child.parentNode) && child !== parent) {
        }
        return !!child;
    }

    static removeElementById(elementId) {
        let element = document.getElementById(elementId)
        if (element) {
            element.remove()
            return false
        }
        throw 'Element not found. elementId:' + elementId
    }
}


class NorseForm {
    static DEFAULT_FORM_ID = 'default-form-id'

    constructor(id = null) {
        if (!id) {
            this.norseData = new NorseClientData({})
            return
        }
        this.formId = id
        let element = document.getElementById(id)
        if (this._isFormElement(element)) {
            this.norseData = new NorseClientData(element)
            return
        }

        let data = NorseElement.extractInputDataFromElement(element)
        this.norseData = new NorseClientData(data)
    }

    getData() {
        return this.norseData
    }

    getDataAsDict() {
        return this.norseData.getDataAsDict()
    }

    getFormId() {
        return this.formId
    }

    addFields(data) {
        Object.entries(data).forEach(([key, value]) => {
            if (value instanceof Array) {
                this._addFormsetField(key, value)
            } else {
                this.norseData.addData(key, value)
            }
        });
    }

    addFiles(key, array) {
        array.forEach(value => {
            this.norseData.addData(key, value)
        })
    }

    // the added data has to be an array of dicts
    _addFormsetField(name, arrayOfDicts) {
        let value = JSON.stringify(arrayOfDicts)
        this.norseData.addData(name, value)
    }

    _isFormElement(element) {
        return element instanceof HTMLFormElement
    }
}

function getObjectByPk(pk, array) {
    for (let i = 0; i < array.length; ++i) {
        if (pk === array[i].pk) {
            return array[i]
        }
    }
    return null
}

function getObjectFromArray(array, key, value) {
    return array.find(obj => obj[key] === value)
}

/*
*   This is the safe variant of Objects.assign
*   d2 has precedence over d1
* */
function mergeTwoDicts(d1, d2) {
    return [d1, d2].reduce(function (r, o) {
        Object.keys(o).forEach(function (k) { r[k] = o[k]; });
        return r;
    }, {});
}

function removeFromArray(arr, value) {
    for (let i = 0; i < arr.length; i++) {
        if (arr[i] === value) {
            arr.splice(i, 1);
            i--;
        }
    }
}

function removeFromArrayByPk(arr, pk) {
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].pk === pk) {
            arr.splice(i, 1);
            i--;
        }
    }
}

/*
*   Returns:  keys that
* */
function getSameKeys(d1, d2) {
    let keys = []
    for (const key in d1) {
        if (key in d2) {
            keys.push(key)
        }
    }
    return keys
}

function getErrorTitleFromResponse(errorResponseDataStr){
    let pattern = '<title>'
    const index = errorResponseDataStr.search(pattern)
    if(index !== 0 && index !== -1) {
        const startIndex = index + pattern.length
        pattern = ' at '
        const endIndex = errorResponseDataStr.search(pattern)

        if(endIndex !== 0 && endIndex !== -1) {
            return errorResponseDataStr.substring(startIndex, endIndex)
        }
    }
    return null
}
// const EventBus = new Vue()

class Constants {
}

Constants.DATE_FORMAT = 'YYYY-MM-DD'
Constants.TIME_FORMAT = 'HH:mm'
Constants.WEEKDAYS_DEFAULT = [1, 2, 3, 4, 5, 6, 0]
Constants.STATE_COLOR_MAP = {
    1: 'secondary',
    2: 'warning',
    3: 'info',
    4: 'success',
    5: 'error',
}

class StatusCodes {
}

StatusCodes.HTTP_200_OK = 200
StatusCodes.HTTP_201_CREATED = 201
StatusCodes.HTTP_202_ACCEPTED = 202
StatusCodes.HTTP_403_FORBIDDEN = 403
StatusCodes.HTTP_408_REQUEST_TIMEOUT = 408
StatusCodes.HTTP_500_INTERNAL_SERVER_ERROR = 500


Constants.Map = {
    MARKER_ACTIVE_ICON_NON_EXISTING: '/static/img/map_images/marker_icon_active_non_existing.png',
    MARKER_ACTIVE_ICON_NON_EXISTING_REMOVE: '/static/img/map_images/marker_icon_active_non_existing_remove.png',
    MARKER_ACTIVE_ICON_EXISTING: '/static/img/map_images/marker_icon_active.png',
    MARKER_IO_ICON: '/static/img/map_images/io_facility_2.svg',
    MARKER_IO_MAIN_ICON: '/static/img/map_images/io_facility_main_2.svg',
    MARKER_INACTIVE_ICON: '/static/img/map_images/marker_icon_inactive.png',
    MARKER_USER_ICON: '/static/img/map_images/marker_icon_user.png',
    MARKER_CONNECTED_BUILDING_ICON: '/static/img/map_images/marker_icon_connected_to_building.png',
    MARKER_CLUSTER_ICON: '/static/img/map_images/clusters/m',
    DEFAULT_CENTER: {lng: 15.62, lat: 56.2},
    DEFAULT_ZOOM: 10,
    SELECTED_MARKER_ZOOM: 18,
    MARKER_CLUSTER_STYLE_M1: {
        textColor: '#323e4b',
        fontWeight: 'bold',
        textSize: 16,
        url: `/static/img/map_images/clusters/m1.png`,
        height: 35,
        width: 35,
        anchorText: [8, 0]
    },
    MARKER_CLUSTER_STYLE_M2: {
        textColor: '#323e4b',
        fontWeight: 'bold',
        textSize: 16,
        url: `/static/img/map_images/clusters/m2.png`,
        height: 40,
        width: 40,
        anchorText: [12, 0]
    },
    MARKER_CLUSTER_STYLE_M3: {
        textColor: '#323e4b',
        fontWeight: 'bold',
        textSize: 16,
        url: `/static/img/map_images/clusters/m3.png`,
        height: 50,
        width: 50,
        anchorText: [16, 0]
    },
    MARKER_CLUSTER_STYLE_M4: {
        textColor: '#3c5064',
        fontWeight: 'bold',
        textSize: 16,
        url: `/static/img/map_images/clusters/m4.png`,
        height: 50,
        width: 50,
        anchorText: [15, 0]
    }
}

class NorseLoader {
    constructor() {
        this.actions = []
    };

    isLoading() {
        return this.actions.length > 0
    }

    isActionLoading(action) {
        return this.actions.includes(action)
    }


    _clearActions() {
        this.actions = []
    }

    dispatchStartLoading(action_id) {
        this.actions = [...this.actions, action_id]
    }

    dispatchStopLoading(action_id) {
        if (!action_id) {
            //Should mean that the view does not have any other actions.
            //safe to remove "all" actions
            this._clearActions()
            return
        }
        if (this.isActionLoading(action_id)) {
            this.actions = this.actions.filter((x) => {
                return x !== action_id
            })
        }

    }
}

class ErrorHandler {
    static processError(toaster, error, ignore_status) {
        if (error instanceof JSONBadRequestError) {
            if (error.response.data.message) {
                toaster.addMessage(error.response.data.message, 'error')
                return
            }

            toaster.addMessage(error.response.statusText, 'error')
            return
        }

        if (error.response) {
            toaster.addMessage(error.response.statusText, 'error')

            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data);
            // console.log(error.response.status);
            if (ignore_status && error.response.status === ignore_status) {
                return
            }
            if (error.response.status === HttpStatus.INTERNAL_SERVER_ERROR) {
                this.processUnexpectedError(toaster, error)
                return
            }

            let msg = this._resolveMsg(error.response)
            console.error(msg)
            return
        }
        if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest

            // app.showErrorMessage("Unhandled error");
            console.log('ERROR:', error)
            return
        }
        if (error instanceof PromiseRejectionEvent) {
            if (error.reason) {
                if (error.reason.response) {
                    let msg = this._resolveMsg(error.reason.response)
                    // app.showErrorMessage(msg + ", unhandled");
                    console.error(msg + ', unhandled')
                    return
                }
                // app.showErrorMessage(error.reason + " (unhandled)");
                console.error(error.reason + ' (unhandled)')
                return
            }
        }

        if (error instanceof NetworkError) {
            toaster.addMessage(error.message, 'error')
        }

        // Something happened in setting up the request that triggered an Error
        // app.showErrorMessage(error);
        console.error(error)
    }

    static processUnexpectedError(toaster, error, actionId = null) {
        let sentry_msg = 'Unexpected internal server error'
        const response = error.response
        if (response.status === HttpStatus.INTERNAL_SERVER_ERROR) {
            const errorTitle = getErrorTitleFromResponse(response.data)
            if (errorTitle) {
                sentry_msg = 'Internal server error: ' + errorTitle
            }
            if (!errorTitle) {
                sentry_msg = 'Unexpected internal server error'
            }
        }

        if (actionId) {
            sentry_msg += ' on: ' + actionId
        }

        if (!error.originalError) {
            Sentry.captureException(error)
            console.error(error)
            toaster.addMessage(error.message, 'error')
            return
        }

        console.error(error)
        error.originalError.message = sentry_msg
        Sentry.captureException(error.originalError)
        toaster.addMessage('Unexpected error occurred', 'error')
    }

    static _resolveMsg(response) {
        console.log('resolve msg', response)
        let msg = ''
        if (response.data) {
            if (response.data.message) {
                msg = response.data.message + ', ' + response.statusText + ' (' + response.status + ')'
                return msg
            }

            if (typeof response.data !== 'string') {
                return 'response.data is dict but does not contain a message.'
            }

            msg = '"' + response.data.substring(0, 32) + '", '
        }
        msg = msg + response.statusText + ' (' + response.status + ')'
        return msg
    }
}

class NorseComponent {
    static getError(fieldName, errors, element) {
        if (!element) {
            console.error('Need element to find the error!')
            return null
        }

        for (let formId in errors) {
            if (formId !== NorseForm.DEFAULT_FORM_ID) {
                let parentElement = document.getElementById(formId)
                if (!parentElement) {
                    console.error('Back-end returns errors for form that is not persistent in the DOM!')
                    continue
                }

                const isChild = NorseElement.isChildOf(element, parentElement)
                if (!isChild) {
                    continue
                }
            }

            let formErrors = errors[formId]
            for (let field in formErrors) {
                if (fieldName === field) {
                    return formErrors[field]
                }
            }
        }
        return null
    }
}

const TOAST_TIMER = 8000 // 8 seconds

class NorseToastHandler {

    constructor() {
        this.messages = []
    }

    addMessage(responseMessage, type = 'error') {
        this.messages.push({
            message: responseMessage,
            status: type,
            timeToLive:
                setTimeout(() => {
                    this.messages.shift()
                }, TOAST_TIMER),
            id: Symbol()
        })
    }

    addPersistentMessage(responseMessage, type = 'error') {
        this.messages.push({message: responseMessage, status: type, id: Symbol()})
    }

    addDjangoMessages(norseForm) {
        const WARNING_LEVEL = '30'
        const ERROR_LEVEL = '40'
        for (const key in norseForm.norseData.data) {
            let value = norseForm.norseData.data[key]
            value = value.split(';')
            const level = value[0]
            const message = value[1]
            if (level === WARNING_LEVEL) {
                this.addMessage(message, 'warning')
            } else if (level === ERROR_LEVEL) {
                this.addMessage(message, 'error')
            } else {
                this.addMessage(message, 'success')
            }
        }
    }

    removeMessage(message) {

        const spliceAtIndex = this.messages.findIndex((msg) => msg.id === message.id)

        if (spliceAtIndex === -1)
            return

        //Clear the timeout before removing it from array
        if (this.messages[spliceAtIndex]?.timeToLive) {
            clearTimeout(this.messages[spliceAtIndex].timeToLive)
        }

        this.messages.splice(spliceAtIndex, 1)
    }
}

const VALID_STORAGE_PATHS = [
    '/cab/cases/',
    '/cab/certificates/',
    '/cab/invoicing/',
    '/cab/io-management/',
    '/cab/applications/',
]

class NorseParamHandler {
    constructor() {
        this.builderParams = new Map()
        this.useStorage = VALID_STORAGE_PATHS.includes(window.location.pathname)
        this.usePushState = false

        if (this.useStorage) {
            const sessionParams = sessionStorage.getItem('urlParams_' + window.location.pathname)
            if (sessionParams) {
                this.initialUrlParams = new URLSearchParams(sessionParams)

                this.updateState(sessionParams)
                return
            }
        }
        this.initialUrlParams = new URLSearchParams(window.location.search) // URL as it is when app start
    }

    activatePushState(callback = undefined) {

        function defaultPopState() {
            window.location.reload()
        }

        window.onpopstate = (event) => {
            if (callback) {
                return callback()
            }
            return defaultPopState()
        }
        this.usePushState = true
    }

    deactivatePushState() {

    }

    updateState(params) {
        if (this.usePushState) {
            return window.history.pushState({}, '', params)
        }
        return window.history.replaceState({}, '', params)
    }

    clearInitial() {
        //Useful when we append the searchparams from backend,
        // then we can clean up the search params a little with this method
        this.initialUrlParams = new URLSearchParams()
    }

    registerParamBuilder(prefix) {
        if (!prefix) {
            console.error('Must register a parambuilder with a prefix')
            return
        }
        if (this.builderParams.has(prefix)) {
            return
        }

        let keysToDeleteFromInitial = new Set()
        let newParams = new URLSearchParams()

        for (let [key, value] of this.initialUrlParams.entries()) {
            if (key.includes(prefix)) {
                newParams.append(key, value)
                keysToDeleteFromInitial.add(key)
            }
        }

        keysToDeleteFromInitial.forEach(key => this.initialUrlParams.delete(key))

        const newParamBuilder = new NorseParamBuilder(prefix)
        newParamBuilder.params = newParams
        this.builderParams.set(prefix, newParamBuilder)
    }

    getOrRegisterParamBuilder(prefix) {
        let builder = this.builderParams.get(prefix)
        if (builder) {
            return builder
        }
        this.registerParamBuilder(prefix)
        return this.builderParams.get(prefix)
    }

    setBrowserParams() {
        let builderURLs = []
        this.builderParams.forEach((builder) => {
            const url = builder.getURL()
            if (url) {
                builderURLs.push(builder.getURL())
            }
        })
        const initialString = this.initialUrlParams.toString()
        let url = builderURLs.join('&')
        if (initialString) {
            url = `${url}&${initialString}`
        }

        pHandler.updateState('?' + url)
        this.useStorage && sessionStorage.setItem('urlParams_' + window.location.pathname, '?' + url)
    }

    extractUrlParamsFromSessionStorage() {
        let paramsObject = {}

        for (let i = 0; i < sessionStorage.length; i++) {
            const key = sessionStorage.key(i)
            if (key && key.startsWith('urlParams_')) {
                const pathname = key.replace('urlParams_', '')
                paramsObject[pathname] = sessionStorage.getItem(key)
            }
        }

        return paramsObject
    }

    createJsonBlobFromSessionStorage() {
        const paramsObject = this.extractUrlParamsFromSessionStorage()
        return JSON.stringify(paramsObject)
    }

    parseJsonBlob(jsonBlob) {
        try {
            return JSON.parse(jsonBlob)
        } catch (error) {
            console.error('Error parsing JSON blob:', error)
            return null
        }
    }

    loadParamsIntoSessionStorage(jsonBlob) {
        const paramsObject = this.parseJsonBlob(jsonBlob)

        if (paramsObject) {
            Object.keys(paramsObject).forEach(pathname => {
                const key = 'urlParams_' + pathname
                const value = paramsObject[pathname]
                sessionStorage.setItem(key, value)
            })
        }
    }

}

let pHandler = new NorseParamHandler()


class NorseParamBuilder {
    constructor(prefix = '') {
        this.prefix = prefix.toLowerCase()
        this.useStorage = VALID_STORAGE_PATHS.includes(window.location.pathname)
        const sessionParams = sessionStorage.getItem('urlParams_' + window.location.pathname) || window.location.search
        this.params = new URLSearchParams(sessionParams.split('?')[0])
    }

    _setParam(key, value) {
        this.params.set(`${this.prefix}_${key}`, value)
        this.setBrowserParams()
    }

    _appendParam(key, value) {
        this.params.append(`${this.prefix}_${key}`, value)
    }

    _deleteParam(key) {
        this.params.delete(`${this.prefix}_${key}`)
        this.setBrowserParams()
    }

    _get(key) {
        return this.params.get(`${this.prefix}_${key}`)
    }

    _getAll(key) {
        return this.params.getAll(`${this.prefix}_${key}`)
    }

    setFilterParam(key, value) {
        let cParams = this._getAll(key)

        const strValue = value.toString()
        if (cParams.includes(strValue)) {
            this._deleteParam(key)

            cParams = cParams.filter((p => p !== strValue))
            cParams.forEach((cValue) => {
                this._appendParam(key, cValue)
            })

            this.setBrowserParams()
            return
        }

        if (value) {
            this._appendParam(key, value)
            this.setBrowserParams()
            return
        }
        this._deleteParam(key)
    }

    setQueryParam(query) {
        if (query) {
            this._setParam(NORSE_FILTERS.QUERY, query)
            return
        }
        this._deleteParam(NORSE_FILTERS.QUERY)
    }

    setDateParam(field, date) {
        if (date) {
            this._setParam(`${field}_${NORSE_FILTERS.DATE}`, date)
            return
        }
        this._deleteParam(`${field}_${NORSE_FILTERS.DATE}`)
    }

    setToDateParam(field, date) {
        if (date) {
            this._setParam(`${field}_${NORSE_FILTERS.TO}`, date)
            return
        }
        this._deleteParam(`${field}_${NORSE_FILTERS.TO}`)
    }

    setFromDateParam(field, date) {
        if (date) {
            this._setParam(`${field}_${NORSE_FILTERS.FROM}`, date)
            return
        }
        this._deleteParam(`${field}_${NORSE_FILTERS.FROM}`)
    }

    setOrderParam(order) {
        let currentOrder = this.getOrderParam()

        if (currentOrder === order) {
            this._deleteParam(NORSE_FILTERS.ORDER)
            return
        }

        if (order) {
            this._setParam(NORSE_FILTERS.ORDER, order)
            return
        }
        this._deleteParam(NORSE_FILTERS.ORDER)
    }

    setPageParam(page) {
        if (page >= 1) {
            this._setParam(NORSE_FILTERS.PAGE, page)
            return
        }
        console.error('Page number should be greater than 0')
        this._setParam(NORSE_FILTERS.PAGE, 1)
    }

    setTabParam(tab) {
        if (tab >= 1) {
            this._setParam(NORSE_FILTERS.TAB, tab)
            return
        }
        console.error('Tab number should be greater than 0')
        this._setParam(NORSE_FILTERS.TAB, 1)
    }

    setChecklistParam(id, dict) {
        if (dict !== undefined) {
            this._setParam(id, dict)
            return
        }

        this._deleteParam(id)
    }

    setBrowserParams() {
        pHandler.setBrowserParams(this.prefix)
        this.useStorage && sessionStorage.setItem('urlParams_' + window.location.pathname, window.location.search)
    }

    getURL() {
        return this.params.toString()
    }

    getFilterParam(key) {
        return this._get(key)
    }

    getAllFilterParams(key) {
        return this._getAll(key)
    }

    getChecklistParam(id) {
        return this._get(id)
    }

    setCustomParam(key, value) {
        this._setParam(key, value)
    }

    getCustomParam(key) {
        return this._get(key)
    }

    getQueryParam() {
        return this._get(NORSE_FILTERS.QUERY)
    }

    getDateParam(field) {
        return this._get(`${field}_${NORSE_FILTERS.DATE}`)
    }

    getToDateParam(field) {
        return this._get(`${field}_${NORSE_FILTERS.TO}`)
    }

    getFromDateParam(field) {
        return this._get(`${field}_${NORSE_FILTERS.FROM}`)
    }

    getOrderParam() {
        return this._get(NORSE_FILTERS.ORDER)
    }

    getTabParam() {
        let tab = this._get(NORSE_FILTERS.TAB)
        return tab ? parseInt(tab, 10) : null
    }

    getPageParam() {
        let page = this._get(NORSE_FILTERS.PAGE)
        return page ? parseInt(page, 10) : null
    }

    setBrowserParams() {
        pHandler.setBrowserParams(this.prefix)
        this.useStorage && sessionStorage.setItem('urlParams_' + window.location.pathname, window.location.search)
    }

    clearParams() {
        pHandler.updateState(' ')
    }

    getBuilderURL() {
        return this.params.toString()
    }

    getBrowserParamsDict() {
        let localKeys = []
        for (let key of this.params.keys()) {
            if (key.includes(this.prefix)) {
                localKeys.push(key)
            }
        }

        let paramObj = {}
        for (let [key, value] of this.params.entries()) {
            if (!localKeys.includes(key)) {
                continue
            }
            const values = this.params.getAll(key)
            // Local key would be the key seen in the url prefix_key; i.e. all_cases_table_page
            //In order to easier maintain
            let localKey = key.split(`${this.prefix}_`)[1] || key
            if (values?.length > 1) {
                paramObj[localKey] = values
                continue
            }
            paramObj[localKey] = value
        }
        return paramObj
    }

    isAscending() {
        return this._get(NORSE_FILTERS.ORDER)?.charAt(0) === '-'
    }

    extractUrlParamsFromSessionStorage() {
        let paramsObject = {}
        const item = sessionStorage.getItem('urlParams_' + window.location.pathname)
        if (item) {
            paramsObject[window.location.pathname] = item
        }

        return paramsObject
    }
}


class BREAKPOINTS {
}

BREAKPOINTS.TABLET = 1024
BREAKPOINTS.MOBILE = 670

class DEVICE {
}

DEVICE.DESKTOP = 'DESKTOP'
DEVICE.TABLET = 'TABLET'
DEVICE.MOBILE = 'MOBILE'


const FIELD_INPUT_CHOICES = {
    TEXT_INPUT: 1,
    FILE_INPUT: 2,
    FILE_INPUT_MULTIPLE: 5,
    RADIO_INPUT: 3,
    CHOICE_INPUT: 4,
}


class NorseBreakpoint {

    constructor() {
        this.currentDevice = DEVICE.DESKTOP
        this.resizeObserver = null
    }

    getCurrentDevice() {
        return this.currentDevice
    }

    initResizeObserver(HtmlElement) {
        this.resizeObserver = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
                const treeWidth = entry.contentRect.width
                let newDevice = DEVICE.DESKTOP

                //ToDO; find a nice way to utilize isOverflowing
                const isOverflowing = entry.target.clientWidth < entry.target.scrollWidth

                if (treeWidth <= BREAKPOINTS.TABLET) {
                    newDevice = DEVICE.TABLET
                }

                if (treeWidth <= BREAKPOINTS.MOBILE) {
                    newDevice = DEVICE.MOBILE
                }

                if (newDevice !== this.currentDevice) {
                    this.currentDevice = newDevice
                }
            })
        })

        this.resizeObserver.observe(HtmlElement)
    }
}

class NorseVue {
    constructor(options = {}) {
        this.data = options.data || {}
        this.components = options.components || {}
        this.computed = options.computed || {}
        this.methods = options.methods || {}
        this.directives = options.directives || {}
        this.watch = options.watch || {}

        this.beforeCreate = options.beforeCreate || function () {
        }
        this.created = options.created || function () {
        }
        this.mounted = options.mounted || function () {
        }
        this.unmounted = options.unmounted || function () {
        }

        this.provide = options.provide || function () {
            return []
        }
    }

    extend(options) {
        Object.assign(this.data, options.data || {})
        Object.assign(this.components, options.components || {})
        Object.assign(this.computed, options.computed || {})
        Object.assign(this.methods, options.methods || {})
        Object.assign(this.directives, options.directives || {})
        Object.assign(this.watch, options.watch || {})

        const providedValue = this.provide()
        this.provide = () => [...options.provide(), ...providedValue]

        let beforeCreateFunc = this.beforeCreate
        this.beforeCreate = function () {
            beforeCreateFunc.call(this)
            options.beforeCreate && options.beforeCreate.call(this)
        }
        let createdFunc = this.created
        this.created = function () {
            createdFunc.call(this)
            options.created && options.created.call(this)
        }
        let mountedFunc = this.mounted
        this.mounted = function () {
            mountedFunc.call(this)
            options.mounted && options.mounted.call(this)
        }
        let unmountedFunc = this.unmounted
        this.unmounted = function () {
            unmountedFunc.call(this)
            options.unmounted && options.unmounted.call(this)
        }
    }

    /*
    `provide()` must be defined as a method which returns
    list of variable names declared in the `data` option.
    */

    /*
      baseVue: Array,
      baseProvided: Array,
  */
    provider(baseVue, baseProvided) {
        let pageControllerProvided = this.provide() //returns object
        let pcKeys = Object.keys(pageControllerProvided)
        let variable_list = baseProvided

        if (pcKeys?.length > 0) {
            variable_list = variable_list.concat(pcKeys)
        }

        let provided = {}
        for (let i = 0; i < variable_list.length; ++i) {
            let variable_name = variable_list[i]
            provided[variable_name] = Vue.computed(() => baseVue[variable_name])
        }
        return provided
    }
}

let norseVue = new NorseVue()

const CP_RESULT_STATES = {
    NOT_SET: 1,
    OK: 2,
    NOT_OK: 3,
    CORRECTED: 4,
    CORRECTED_OK: 5,
    NOT_APPLICABLE: 6
}

const SHOW_SECTION = {
    HIDDEN: 'hidden',
    INSTRUCTION: 'instruction',
    REJECTION: 'rejection',
    COMMENT: 'comment'
}

class SeverityValue {
    constructor(data) {
        this.pk = data.pk
        this.name = data.name
        this.shortName = data.short_name
        this.description = data.description
        this.level = data.level
        this.sortWeight = data.sort_weight
    }

    get isRejectionValue() {
        return this.level !== SeverityValue.LEVEL_OK
    }

    static asItems(json) {
        return json.map(jsonItem => {
            return new SeverityValue(jsonItem)
        })
    }
}

SeverityValue.LEVEL_OK = 1

class ChecklistResult {
    constructor(data) {
        this.pk = data.pk
        this.state = data.state
    }
}

class NorseCard {
    constructor(data, level) {
        this.pk = data.pk
        this.level = level ? level + 1 : 1
        this.kind = data.kind || ''
        this.active = data.active || false
        this.cards = data.cards ? NorseCard.asItems(data.cards, this.level) : []
        this.showSection = SHOW_SECTION.HIDDEN
    }

    get refId() {
        return `${this.level}-${this.kind}-${this.pk}`
    }

    get isControlPoint() {
        return this.isKind(KINDS.CONTROL_POINT)
    }

    get isGroup() {
        return this.isKind(KINDS.GROUP)
    }

    get isBuilding() {
        return this.isKind(KINDS.BUILDING)
    }

    get isSystem() {
        return this.isKind(KINDS.SYSTEM)
    }

    get isAirFlow() {
        return this.isKind(KINDS.AIR_FLOW)
    }

    get showInstruction() {
        return this.isSection(SHOW_SECTION.INSTRUCTION)
    }

    get showRejection() {
        return this.isSection(SHOW_SECTION.REJECTION)
    }

    get showComment() {
        return this.isSection(SHOW_SECTION.COMMENT)
    }

    get childsCount() {
        return this.cards.length
    }

    static getCardsForLevel(cards, level) {
        if (!cards || !cards.length) {
            return []
        }

        let isLevel = cards.some(card => card.level === level)
        if (isLevel) {
            return cards
        }
        let activeCard = cards.find(card => card.active)
        cards = activeCard ? activeCard.cards : []
        return NorseCard.getCardsForLevel(cards, level)
    }

    // sets property active to false for all cards in a certain level
    static resetCardsForLevel(cards, level) {
        let levelCards = NorseCard.getCardsForLevel(cards, level)
        for (let card of levelCards) {
            card.active = false
        }
    }

    // sets property active to false for all cards (children, grandchildren, etc.) of a certain card
    resetCardChildren() {
        if (!this.cards.length) {
            return
        }
        for (let card of this.cards) {
            card.active = false
            card.resetCardChildren()
        }
    }

    /*****************************************
     * Section action
     ****************************************/
    setShowSection(value) {
        if (!Object.values(SHOW_SECTION).includes(value)) {
            throw `Section with value ${value} is not defined.`
        }

        this.showSection = value
    }

    toggleSection(section) {
        if (this.showSection === section) {
            section = SHOW_SECTION.HIDDEN
        }

        this.setShowSection(section)
        this.rerender++
    }

    toggleInstructionSection() {
        this.toggleSection(SHOW_SECTION.INSTRUCTION)
    }

    toggleRejectionSection() {
        this.toggleSection(SHOW_SECTION.REJECTION)
    }

    toggleCommentSection() {
        this.toggleSection(SHOW_SECTION.COMMENT)
    }

    /*****************************************
     *
     ****************************************/
    isKind(kind) {
        return this.kind === kind
    }

    isSection(section) {
        return this.showSection === section
    }

    static asItems(json, level) {
        return json.map(jsonItem => {
            switch (jsonItem.kind) {
                case KINDS.BUILDING:
                    return new BuildingCard(jsonItem, level)
                case KINDS.SYSTEM:
                    return new SystemCard(jsonItem, level)
                case KINDS.SYSTEM_INSPECTION:
                    return new SystemInspectionCard(jsonItem, level)
                case KINDS.AIR_FLOW:
                    return new AirFlowCard(jsonItem, level)
                default:
                    return new ChecklistCard(jsonItem, level)
            }
        })
    }
}

class ChecklistCard extends NorseCard {
    constructor(data, level) {
        super(data, level)
        this.name = data.name || data.group_label || data.content?.name || ''
        this.numbering = data.numbering || ''
        this.instruction = data.content?.instruction || ''
        this.controlPoints = ChecklistCard.setControlPoints(this.cards, this.pk)
        this.result = new ChecklistResult(data.result || {
            pk: '',
            state: CP_RESULT_STATES.NOT_SET
        })
        this.severityValues = SeverityValue.asItems(data.severity_values || [])
        this.CPComments = JSON.parse(JSON.stringify(Object.values(CP_COMMENTS).slice()))
        this.severityValue = new SeverityValue(data.result?.severity_value || {})
        this.rejectionComment = data.rejection?.text || ''
        this.rejectionFiles = []
        this.image = data.rejection?.image ? data.rejection.image : ''
        this.commentFiles = []
        this.comment = data.comment?.text || ''
        this.commentType = ''
        this.improvementFiles = []
        this.improvement = data.improvement?.text || ''
        this.rerender = 0
        this.showDefaultRejection = this.rejectionComment === ''

        if (this.comment === '' && this.improvement !== '') {
            this.CPComments.forEach(value => {
                value.selected = !value.selected
            })
        }
    }

    get isApproved() {
        return this.isResultState(CP_RESULT_STATES.OK)
    }

    get isRejected() {
        return this.isResultState(CP_RESULT_STATES.NOT_OK)
    }

    get isNotSet() {
        return this.isResultState(CP_RESULT_STATES.NOT_SET)
    }

    get isNotApplicable() {
        return this.isResultState(CP_RESULT_STATES.NOT_APPLICABLE)
    }

    get isCommented() {
        return !!this.comment || !!this.improvement
    }

    get controlPointsCount() {
        return this.controlPoints.length
    }

    get controlPointsApprovedCount() {
        return this.controlPoints.filter(p => p.isApproved).length
    }

    get controlPointsRejectedCount() {
        return this.controlPoints.filter(p => p.isRejected).length
    }

    get controlPointsHandledCount() {
        return this.controlPointsApprovedCount + this.controlPointsRejectedCount
    }

    get selectedSeverityValue() {
        let selected = this.severityValues.find(val => val.selected)
        return selected && selected.level
    }

    get selectedCommentImprovement() {
        let selected = this.CPComments.find(val => val.selected)
        return selected.id === CP_COMMENTS.Improvement.id
    }

    get rejectionValues() {
        return this.severityValues.filter(_value => {
            return _value.isRejectionValue
        })
    }

    get approvalValues() {
        return this.severityValues.filter(_value => {
            return !_value.isRejectionValue
        })
    }

    get commentValues() {
        return this.CPComments
    }

    static setControlPoints(cards) {
        return ChecklistCard.getControlPointsForCard({cards: cards})
    }

    static getControlPointsForCard(card) {
        let cpoints = []
        for (let child of card.cards) {
            if (child.isControlPoint) {
                cpoints.push(child)
            } else {
                cpoints = cpoints.concat(ChecklistCard.getControlPointsForCard(child))
            }
        }
        return cpoints
    }

    closeDefaultRejection(_comment = null) {
        if (_comment) {
            this.rejectionComment = _comment.text
        }
        this.showDefaultRejection = false
    }

    openDefaultReject() {
        this.showDefaultRejection = true
    }

    setResultState(state) {
        if (!Object.values(CP_RESULT_STATES).includes(state)) {
            throw `State ${state} is not defined.`
        }

        this.result.state = state
    }

    setResultOK() {
        this.result.state = CP_RESULT_STATES.OK
    }

    setResultNotOK() {
        this.result.state = CP_RESULT_STATES.NOT_OK
    }

    setResultNotSet() {
        this.result.state = CP_RESULT_STATES.NOT_SET
    }

    /*****************************************
     * State action
     ****************************************/
    toggleState(state) {
        if (this.result.state === state) {
            state = CP_RESULT_STATES.NOT_SET
        }

        this.setResultState(state)
    }

    toggleApproval() {
        this.toggleState(CP_RESULT_STATES.OK)
        this.toggleSection(SHOW_SECTION.HIDDEN)
    }

    toggleRejection() {
        this.toggleState(CP_RESULT_STATES.NOT_OK)
        this.toggleSection(SHOW_SECTION.HIDDEN)
    }

    toggleNotApplicable() {
        this.toggleState(CP_RESULT_STATES.NOT_APPLICABLE)
        this.toggleSection(SHOW_SECTION.HIDDEN)
    }

    isResultState(state) {
        return this.result.state === state
    }
}

const sermiConstants = {
    SORT: {
        ASCENDING: 1,
        DESCENDING: 2,
        NONE: 3,
    }
}

class DISTRIBUTION_TYPES {

}

DISTRIBUTION_TYPES.PAPER = '1'
DISTRIBUTION_TYPES.EMAIL = '2'
DISTRIBUTION_TYPES.EDI = '3'

// Corresponds to FieldControlPointResultChoices
const FIELD_CONTROL_POINT_RESULT = {
    NOT_SET: 1,
    APPROVED: 2,
    REJECTED: 3,
    RESOLVED: 4
}

// Corresponds to CaseReviewStepChoices
const CASE_REVIEW_STEP_CHOICES = {
    COMPANY_DETAILS: 1,
    LEGAL_INFORMATION: 2,
    MANAGING_DIRECTOR: 3,
    RECOMMENDATION: 4
}

// Corresponds to `RecommendationChoices`
const RECOMMENDATION_CHOICES = {
    APPROVAL: 1,
    REJECTION: 2,
    NOT_SET: 3
}

const CASE_RESULT_CHOICES = {
    APPROVED: 1,
    REJECTED: 2
}

const IOE_CASE_REVIEW_STEP_CHOICES = {
    PERSONAL_DETAILS: 1,
    RECOMMENDATION: 2
}

const REVIEW_CHAT_TAB_CHOICES = {
    NON_CONFORMITIES: 1,
    COMMENTS: 2
}

const CAB_DASHBOARD_TAB_CHOICES = {
    ONGOING: 1,
    PENDING: 2,
    EXTRA_REVIEW: 3,
}
const INSPECTOR_DASHBOARD_TAB_CHOICES = {
    ONGOING: 1,
    PLANNED: 2,
    FINISHED: 3,
}

const CAB_CASES_TAB_CHOICES = {
    ONGOING: 1,
    PENDING: 2,
    DONE: 3,
    ALL: 4,
}

const APPLICATION_TAB_CHOICES = {
    APPLICATIONS: 1,
}


const NORSE_FILTERS = {
    FILTER: 'filter',
    ORDER: 'order',
    QUERY: 'query',
    PAGE: 'page',
    TAB: 'tab',
    FROM: 'from',
    TO: 'to',
    DATE: 'date',
    PAGE_CONTROLLER: 'pc',
    CHECKLIST: 'checklist',
    CUSTOM: 'custom',
}

const CERTIFICATE_STATES = {
    DRAFT: '1',
    VALID: '2',
    REVOKED: '3',
    SUSPENDED: '4',
}

const IOE_APPLICATION_STATES = {
    DRAFT: 1,
    PENDING: 2,
    PENDING_INVITE: 6,
    INVITE_SENT: 3,
    CONFIRMED: 4,
    COMPLETED: 5
}

const APPLICATION_RESULT_STATE = {
    CASE_CREATED: 1,
    CANCELLED: 2,
    RESTORED: 3,
}

const INSPECTION_DECISION_CHOICES = {
    APPROVED: 1,
    REJECTED: 2,
}

const SPOT_CHECK_TYPES = {
    FACILITY: 1,
    IOE: 2,
}

const CP_CONVERSATION_ITEM_TYPES = {
    REJECTION: 1,
    RESPONSE: 2,
    COMMENT: 3,
}

// Corresponds to `NonConformityTypes`
const NON_CONFORMITY_TYPES = {
    ENTRY_CASE: 1,
    FACILITY_SPOT_CHECK: 2,
    IOE_SPOT_CHECK: 3,
    RENEWAL: 4,
}

const MAPBOX_AUTOFILL_FIELDS = {
    postalCode: 'postal_code',
    postalCity: 'postal_city'
}

const MAPBOX_FACILITY_ICONS = {
    FACILITY: "url('/static/img/map_images/marker_icon_active.png')",
    PENDING_FACILITY: "url('/static/img/map_images/marker_icon_user.png')"
}


const NORSE_MAP_MARKER = {
    WIDTH: '41px',
    HEIGHT: '58px',
    CLASS_NAME: 'norse-marker',
}


const NORSE_MAP_LAYER_STYLES = {
    STREETS: 'streets',
    SATELLITE: 'satellite',
}

const MAPBOX_GEOLOCATION_COUNTRIES = [
    'SE', 'DK', 'FI', 'NO'
]

const ASSENTLY_PROVIDER_SETTINGS= {
    'no-bankid-oidc': {
        ux_mode: 'popup'
    }
}


// TODO: Below code is boilerplate and should be modified
class Style {
    static getSomeStateColorClass(state, result) {

        if (result) {
            switch (result) {
                case PLACEHOLDER.COMPLETED:
                    return 'item-status-label done';
                case PLACEHOLDER.CANCELLED:
                    return 'item-status-label cancelled';
                default:
                    break;
            }
        }

        switch (state) {
            case PLACEHOLDER.CREATED:
                return 'item-status-label';
            case PLACEHOLDER.DONE:
                return 'item-status-label done';
            case PLACEHOLDER.CONFIRMED:
                return 'item-status-label confirmed';
            case PLACEHOLDER.ONGOING:
                return 'item-status-label ongoing';
            case PLACEHOLDER.IN_REVIEW:
                return 'item-status-label in-review';
            default:
                return 'item-status-label';
        }
    }

    static getSomeStateColorClass2(state) {
        switch (state) {
            case PLACEHOLDER.CREATED:
                return 'n-label label-left';
            case PLACEHOLDER.DONE:
                return 'n-label label-left approved';
            case PLACEHOLDER.CONFIRMED:
                return 'n-label label-left confirmed';
            case PLACEHOLDER.ONGOING:
                return 'n-label label-left ongoing';
            case PLACEHOLDER.IN_REVIEW:
                return 'n-label label-left in-review';
            default:
                return 'n-label label-left';
        }
    }
}

class Input {
    static incrementDateOneDay(date) {
        const newEndDate = moment(new Date(date))
        return newEndDate.add(1, 'd').format(Constants.DATE_FORMAT)
    }

    static decrementDateOneDay(date) {
        const newEndDate = moment(new Date(date))
        return newEndDate.add(-1, 'd').format(Constants.DATE_FORMAT)
    }

    // borrowed with slight modification from: https://stackoverflow.com/a/57272491/7247964
    static toBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result); //result is a string
            reader.onerror = error => reject(error);
        })
    }
}

class WorkOrders {
    static filterCreated(workOrders) {
        return workOrders.filter(wo => wo.state === WORK_ORDER_STATES.CREATED)
    }

    static filterConfirmed(workOrders) {
        return workOrders.filter(wo => wo.state === WORK_ORDER_STATES.CONFIRMED)
    }

    static filterOngoing(workOrders) {
        return workOrders.filter(wo => wo.state === WORK_ORDER_STATES.ONGOING)
    }

    static filterInReview(workOrders) {
        return workOrders.filter(wo => wo.state === WORK_ORDER_STATES.IN_REVIEW)
    }

    static filterDone(workOrders) {
        return workOrders.filter(wo => wo.state === WORK_ORDER_STATES.DONE)
    }

    static filterByStates(workOrders, states) {
        return workOrders.filter(wo => states.includes(wo.state))
    }
}

class Checklist {
    static getFirstBuildingCard(checklist) {
        if (checklist.length === 0 || checklist[0].length === 0) {
            console.error('Checklist is empty!')
            return undefined
        }
        return checklist[0][0]
    }

    static getFirstSystemCard(checklist) {
        if (checklist.length < 2) {
            console.error('Invalid checklist!')
            return undefined
        }
        for (let i = 0; i < checklist[1].length; ++i) {
            const card = checklist[1][i]
            if (card.content.kind === CHECKLIST_CARD_KINDS.SYSTEM) {
                return card
            }
        }
        console.error('No system card found in second layer!')
        return undefined
    }

    static getSystemChecklistCard(checklist, systemPk) {
        if (checklist.length < 2) {
            console.error('Invalid checklist!')
            return undefined
        }
        for (let i = 0; i < checklist[1].length; ++i) {
            const card = checklist[1][i]
            if (card.content.kind === CHECKLIST_CARD_KINDS.SYSTEM_CHECKLIST
                || systemPk === card.content.pk) {
                return card
            }
        }
        console.error('No system checklist card found in second layer!')
        return undefined
    }

    static isWithSingleBuilding(checklist) {
        if (checklist.length === 0 || checklist[0].length === 0) {
            console.error('Checklist is empty!')
            return false
        }
        return checklist[0].length === 1
    }
}


class MapBox {

    static async getRoute(end) {
        // make a directions request using cycling profile
        // an arbitrary start will always be the same
        // only the end or destination will change
        const query = await fetch(
            `https://api.mapbox.com/directions/v5/mapbox/cycling/${start[0]},${start[1]};${end[0]},${end[1]}?steps=true&geometries=geojson&access_token=${mapboxgl.accessToken}`,
            {method: 'GET'}
        );
        const json = await query.json();
        const data = json.routes[0];
        const route = data.geometry.coordinates;
        const geojson = {
            type: 'Feature',
            properties: {},
            geometry: {
                type: 'LineString',
                coordinates: route
            }
        };
        // if the route already exists on the map, we'll reset it using setData
        if (map.getSource('route')) {
            map.getSource('route').setData(geojson);
        }
        // otherwise, we'll make a new request
        else {
            map.addLayer({
                id: 'route',
                type: 'line',
                source: {
                    type: 'geojson',
                    data: geojson
                },
                layout: {
                    'line-join': 'round',
                    'line-cap': 'round'
                },
                paint: {
                    'line-color': '#3887be',
                    'line-width': 5,
                    'line-opacity': 0.75
                }
            });
        }
        // add turn instructions here at the end
    }
}
